import type { Kid } from "@starquest/core";
import { DEFAULT_THEME_ID } from "@starquest/core";

interface Props {
  kid?: Kid | null;
  children: React.ReactNode;
}

export default function ThemeWrapper({ kid, children }: Props) {
  const themeId = kid?.theme ?? DEFAULT_THEME_ID;
  return (
    <div data-theme={themeId} style={{ minHeight: "100vh" }}>
      {children}
    </div>
  );
}
